import { MainDashboardComponent } from './main-dashboard/main-dashboard.component';
import { CurtomRouteReuseStrategy } from './custom-route-reuse-strategy.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, RouteReuseStrategy, PreloadAllModules } from '@angular/router';
import { AppMainComponent } from './app.main.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './auth.guard';



const routes: Routes = [
  {
    path: '',
    component: AppMainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        component: MainDashboardComponent,
        loadChildren: () => import('./main-dashboard/main-dashboard.module').then(m => m.MainDashboardModule)
        
      },
      {
        path: 'competitor',
        canActivate: [AuthGuard],
        loadChildren: () => import('./competitors/competitors.module').then(m => m.CompetitorsModule)
      },
      {
        path: 'product',
        canActivate: [AuthGuard],
        loadChildren: () => import('./products/products.module').then(m => m.ProductsModule)
      },
      {
        path: 'system',
        canActivate: [AuthGuard],
        loadChildren: () => import('./system/system.module').then(m => m.SystemModule)
      },
      {
        path: 'tools',
        canActivate: [AuthGuard],
        loadChildren: () => import('./tools/tools.module').then(m => m.ToolsModule)
      },
      {
        path: 'pyramid',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pyramid/pyramid.module').then(m => m.PyramidModule)
      },
      {
        path: 'information',
        canActivate: [AuthGuard],
        loadChildren: () => import('./information/information.module').then(m => m.InformationModule)
      },
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  { path: '**', pathMatch: 'full', redirectTo: '/dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableTracing: false, preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule],
  providers: [{
    provide: RouteReuseStrategy,
    useClass: CurtomRouteReuseStrategy,
  }],
  
})
export class AppRoutingModule { }
